import { 
  FaIndustry, 
  FaWarehouse, 
  FaBuilding, 
  FaShoppingCart, 
  FaHospital, 
  FaPlane 
} from 'react-icons/fa';

export const industriesData = [
  {
    id: 1,
    name: 'Manufacturing',
    icon: FaIndustry,
    description: 'Supporting production facilities with reliable material handling solutions.',
    color: 'catalina-blue'
  },
  {
    id: 2,
    name: 'Warehousing',
    icon: FaWarehouse,
    description: 'Efficient material handling for storage and logistics operations.',
    color: 'tango'
  },
  {
    id: 3,
    name: 'Construction',
    icon: FaBuilding,
    description: 'Durable equipment for construction sites and building projects.',
    color: 'catalina-blue'
  },
  {
    id: 4,
    name: 'Retail',
    icon: FaShoppingCart,
    description: 'Safe and efficient solutions for retail and shopping centers.',
    color: 'catalina-blue'
  },
  {
    id: 5,
    name: 'Healthcare',
    icon: FaHospital,
    description: 'Reliable equipment for hospitals and medical facilities.',
    color: 'tango'
  },
  {
    id: 6,
    name: 'Aviation',
    icon: FaPlane,
    description: 'Specialized solutions for aircraft maintenance and operations.',
    color: 'catalina-blue'
  }
];